import { Component, OnInit, TemplateRef, EventEmitter, Output, Input, OnChanges, ViewChild, OnDestroy } from '@angular/core';
import { PHBHPFeaturePackageUserManagementService } from '../ph-bhp-feature-package-user-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-ph-bhp-manageuser',
  templateUrl: './ph-bhp-manageuser.component.html',
  styleUrls: ['./ph-bhp-manageuser.component.css']
})
export class PhBhpManageuserComponent implements OnInit, OnDestroy {
  userData: any;
  countriesKeyValue: any;
  userList: [any];
  itemChange: boolean = false;
  searchText: any;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteDataItem
  emitData: any = {
    key: "",
    val: ""
  }
  subscription: Subscription;
  userSubscription: Subscription;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  public gridData: any[];

  //public gridData: any[] = products;

  public fields: any[] = [
    { 'field': 'userName', 'title': 'USER_MANAGEMENT.NAME', 'width': 250 },
    { 'field': 'institutionName', 'title': 'USER_MANAGEMENT.INSTITUTIONS' },
    {
      'field': 'city', 'title': 'USER_MANAGEMENT.LOCATION',
      // 'ngTemplate': (dataItem) => {
      //   if (dataItem.institutions[0]) {
      //     if (dataItem.institutions[0].city !== '') {
      //       return this.layoutService.translateText(dataItem.institutions[0].city);
      //     } else {
      //       return dataItem.institutions[0].city;
      //     }
      //   }
      // }
    },
    {
      'field': 'country', 'title': 'USER_MANAGEMENT.COUNTRY', 
      // "ngTemplate": (dataItem) => {
      //   if (dataItem.institutions[0]) {
      //     const countryName = this.layoutService.translateText(this.countriesKeyValue[dataItem.institutions[0].countryID]);
      //     return countryName;
      //   }
      //   else {
      //     return "";
      //   }
      // }
    },
    { 'field': 'email', 'title': 'USER_MANAGEMENT.E_MAIL', 'width': 250 },
    { 'field': 'roleName', 'title': this.translationKeys.ProfileDetails.Role},
    //CONFLICT: field USER.isActive was commented out in phase2. Keep field?
    {
      'field': 'isActive', 'title': 'USER_MANAGEMENT.STATUS',
      // "ngTemplate": (dataItem) => {
      //   return (dataItem.user.isActive) ? `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE')}` : `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.IN_ACTIVE')}`;
      // }
    }
  ];

  actionItems: any = [
    { name: 'USER_MANAGEMENT.VIEW', imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg', onClick: (dataItem) => { this.view(dataItem) } },
    { name: 'USER_MANAGEMENT.EDIT', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', onClick: (dataItem) => { this.edit(dataItem) } },
    { name: 'USER_MANAGEMENT.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } }
  ];

  pageInfo = {
    items: 'USER_MANAGEMENT.USER',
    itemsPerPageLabel: 'USER_MANAGEMENT.USERS_PER_PAGE'
  };


  constructor(
    private router: Router,
    public config: AppConfig,
    private modalService: BsModalService,
    private service: PHBHPFeaturePackageUserManagementService,
    public layoutService: PHBHPLayoutPackageService
  ) { }

  ngOnInit() {
    this.service.getCountriesKeyValuePair().subscribe((res: any) => {
      this.countriesKeyValue = res;
    });
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getAllusers(this.userData.userId)
    })

    if (this.config.userData) {
      this.userData = this.config.userData;
      this.onUserChanges();
    }

    this.userSubscription = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.onUserChanges();
    })

  }

  onUserChanges() {
    if (this.userData && !this.itemChange) {
      this.itemChange = true;
      if (this.userData.roleName.roleId == 2) {
        this.fields.splice(3, 1);
      }
      else if (this.userData.roleName.roleId == 3) {
        this.fields.splice(3, 1);

      } else if (this.userData.roleName.roleId == 4) {
        this.fields.splice(3, 1);
      }
      this.getAllusers(this.userData.userId)
    }
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  getAllusers(userId) {
    this.layoutService.showLoader = true;
    this.service.getAllUsers(userId).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      const that = this;
      this.gridData = res.map(item => this.manageGrid(item, that));
      this.changeLangCommentPage();
    })
  }

  changeLangCommentPage() {
    this.gridData.forEach((value, index) => {
      if (this.gridData[index].role.roleName)
        this.gridData[index].role.roleName = this.layoutService.translateText(value.role.roleName);
    });
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  delete() {
    this.service.deleteUser(this.deleteDataItem.user.userId).subscribe(((res: any) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      var index = data.findIndex(user => user.user.userId === this.deleteDataItem.user.userId);
      data.splice(index, 1);
      const that = this;
      this.gridData = data.map(item => this.manageGrid(item, that));
    }))
  }

  view(dataItem) {
    this.emitData = {};
    this.emitData.key = 'user/view/' + dataItem.user.userId;
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }

  edit(dataItem) {
    this.emitData = {};
    this.emitData.key = 'user/edit/' + dataItem.user.userId;
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }

  addUser() {
    this.emitData = {};
    this.emitData.key = 'user/add';
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }
  onChildData(event: any) {
    this.router.navigate([event.key]);
  }
  searchTextChange() {
    // this.isCollapsed = [false];
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  manageGrid(item, that){

    item.userName = item.user.name;
  item.country =  "";

    if (item.institutions[0]) {
      if (item.institutions[0].city !== '') {
        item.city = this.layoutService.translateText(item.institutions[0].city);
      } else {
        item.city = item.institutions[0].city;
      }
      item.institutionName = item.institutions[0].institutionName;
      item.country = this.layoutService.translateText(this.countriesKeyValue[item.institutions[0].countryID]);
    }

    item.email = item.user.email;
    item.roleName = item.role.roleName;

    item.isActive = (item.user.isActive) ? `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE')}` : `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.IN_ACTIVE')}`;

    return item;
       
  }

}
